module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('notification-bell', {
    attrs: {
      "notifications": _vm.userNotifications,
      "deleteNotificationFunc": _vm.deleteNotification,
      "actionEngine": _vm.engine
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6295d303"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/common/AudienceMattersNotifications.vue
// module id = 1907
// module chunks = 0